<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Whitelist'"
      :tableHeader="headers"
      :tableRows="listEnderecos"
      :isEdit="true"
      :isFinish="false"
      :isDel="false"
      :isPrint="false"
      v-on:datatable-updaterow="modalView"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal
            :tipo="alertaModal.tipo"
            :texto="alertaModal.texto"
          ></AlertasModal>
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="modalCustomSize.actualEdit.nomeEndereco"
            name="nomeEndereco"
            label="Nome da Unidade"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="modalCustomSize.actualEdit.nomeResponsavel"
            name="nomeResponsavel"
            label="Responsável pela Unidade"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            label="Lista de Produtos padronizados"
            :items="itensSistema"
            v-model="itemSelecionado"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12">
          <DataTable
            v-show="showSkeletonTableModal == false"
            :tableTitle="'Itens padronizados na Unidade: ' + modalCustomSize.actualEdit.nomeEndereco"
            :tableHeader="headersItens"
            :tableRows="itensSistemaUnidade"
            :isDel="true"
            v-on:datatable-deleterow="modalDeletar"
          ></DataTable>

          <SkeletonTable
            v-show="showSkeletonTableModal == true"
            :showSkeletonTable="showSkeletonTableModal"
          ></SkeletonTable>
        </v-col>
      </v-row>
    </ModalCustomSize>

    <DeleteItemModal 
      :showModalDelete="modalDelete.abrir"
      :textModalDelete="modalDelete.texto"
      :buttomTextModalDelete="'Alterar'"
      v-on:close-modal="modalDelete.abrir = false"
      v-on:on-response-modal-delete="deletaItemUnidade"
    ></DeleteItemModal>
  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import axios from "../plugins/axios";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
    DeleteItemModal,
  },

  sockets: {
    reciveInsert: function(data) {
      if (data && data.descricaoTela == "blacklist") {
        this.alertaSocket.texto = "Novos Itens adicionados na Blacklist!";
        this.alertaSocket.tipo = "info";
        this.initialize();
      }
    },
  },

  data: () => ({
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    showSkeletonTable: true,
    showSkeletonTableModal: true,
    loading: false,

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    headers: [
      {
        text: "ID",
        value: "numeroEnderecoOrdemServico",
      },
      {
        text: "Unidade",
        value: "nomeEndereco",
      },
      {
        text: "Responsável pela Unidade",
        value: "nomeResponsavel",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "itemSistemaUnidade.numeroItemSistemaUnidade",
      },
      {
        text: "Nome do Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Descrição do Produto",
        value: "itemSistema.descricaoItemSistema",
      },
      {
        text: "Status para Pedido",
        value: "itemSistemaUnidade.indicadorStatus",
      },
      {
        text: "Quantidade no Estoque",
        value: "quantidadeEstoqueTotal",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: false,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEndereco: null,
        nomeEndereco: null,
        nomeResponsavel: null,
        descricaoTela: "whitelist",
      },
    },

    modalDelete: {
      abrir: false,
      texto: "Deseja realmente deletar este Produto da Unidade selecionada?",
      actualEdit: {
        numeroEndereco: null,
        numeroItemSistemaUnidade: null,
        indicadorStatus: null
      }
    },

    listEnderecos: [],
    itensSistema: [],
    itensSistemaUnidade: [],
    itemSelecionado: null,
  }),

  created() {
    this.initialize();
  },

  watch: {
    itemSelecionado() {
      if(this.itemSelecionado) {
        this.insereItemUnidade(this.itemSelecionado, this.modalCustomSize.actualEdit.numeroEndereco)
      }
    }
  },

  methods: {
    initialize() {
      this.showSkeletonTable = true;
      try {
        this.listaEnderecos()
        this.listaItensSistema()
      } catch (error) {
        console.log(error)
      } finally {
        this.showSkeletonTable = false;
      }
    },

    async listaEnderecos() {
      try {
        let enderecos = await axios.get("enderecoOrdemServico", this.config);
        this.listEnderecos = enderecos.data;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaItensSistema() {
      try {
        let responseItens = await axios.get("itemSistema", this.config);
        
        this.itensSistema = responseItens.data.map(itemSelecionado => {
          return {
            value: itemSelecionado.numeroItemSistema,
            text: itemSelecionado.nomeItemSistema
          }
        });
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaDeItensSistemaUnidade(numeroEndereco) {
      this.showSkeletonTableModal = true
      try {
        let response = await axios.put("itemSistemaUnidade", {numeroEndereco: numeroEndereco, retornarTodos: true,retornarSomenteAtivos: false}, this.config);
        this.itensSistemaUnidade = response.data

        this.erro = false;
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.showSkeletonTableModal = false
      }
    },

    async insereItemUnidade(numeroItemSistema, numeroEndereco) {
      try {
        const verificarItem = this.itensSistemaUnidade.filter(
          (item) => item.itemSistema.numeroItemSistema == numeroItemSistema
        );
        
        if(verificarItem.length > 0) {
          this.alertaModal.texto = "Este item já se encontra disponível para unidade.";
          this.alertaModal.tipo = "erro";
        } else {
          this.alertaModal.tipo = "";
          await axios.post("itemSistemaUnidadeWhitelist", {numeroEndereco: numeroEndereco, numeroItemSistema: numeroItemSistema}, this.config);

          const itemSelecionado = this.itensSistema.filter(
            (item) => item.value == numeroItemSistema
          )[0];

          this.alertaModal.texto = "O item: ' " + itemSelecionado.text + " ' foi adicionado na lista com sucesso!";
          this.alertaModal.tipo = "sucesso";

          this.itemSelecionado = null
          this.listaDeItensSistemaUnidade(numeroEndereco)
        }
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async deletaItemUnidade() {
      try {
        
        await axios.delete("itemSistemaUnidade", {
          data: this.modalDelete.actualEdit,
          headers: this.config.headers,
        });
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.listaDeItensSistemaUnidade(this.modalDelete.actualEdit.numeroEndereco)
        this.modalDelete.abrir = false;
      }
    },

    async modalView(value) {
      this.loading = true
      try {
        this.listaDeItensSistemaUnidade(value.numeroEnderecoOrdemServico)

        this.modalCustomSize.actualEdit.numeroEndereco = value.numeroEnderecoOrdemServico;
        this.modalCustomSize.actualEdit.nomeEndereco = value.nomeEndereco;
        this.modalCustomSize.actualEdit.nomeResponsavel = value.nomeResponsavel;

      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.formTitle = "Whitelist";
        this.modalCustomSize.isOpen = true;
        this.loading = false
      }
    },

    async modalDeletar(itemSelecionado) {
      if(itemSelecionado.itemSistemaUnidade.indicadorStatus == 0) {
        this.modalDelete.texto = "Você realmente deseja ativar esse Item?";
        this.modalDelete.textoBotao = "Ativar";
        this.modalDelete.textoSucesso = "Item Ativado com sucesso!";
        this.modalDelete.actualEdit.numeroEndereco = itemSelecionado.endereco.numeroEnderecoOrdemServico;
        this.modalDelete.actualEdit.numeroItemSistemaUnidade = itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade;
        this.modalDelete.actualEdit.indicadorStatus = 1;
        this.modalDelete.abrir = true;
      }

      if(itemSelecionado.itemSistemaUnidade.indicadorStatus == 1) {
        this.modalDelete.texto = "Você realmente deseja Inativar esse Item?";
        this.modalDelete.textoBotao = "Inativar";
        this.modalDelete.textoSucesso = "Item inativado com sucesso!";
        this.modalDelete.actualEdit.numeroEndereco = itemSelecionado.endereco.numeroEnderecoOrdemServico;
        this.modalDelete.actualEdit.numeroItemSistemaUnidade = itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade;
        this.modalDelete.actualEdit.indicadorStatus = 0;
        this.modalDelete.abrir = true;
      }
    },

  },
};
</script>
